import { render, staticRenderFns } from "./MemberForm.vue?vue&type=template&id=499fbad8&lang=pug&"
import script from "./MemberForm.vue?vue&type=script&lang=js&"
export * from "./MemberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports